"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreakpointTypes = exports.ApiProtocol = exports.AppEnvKeys = void 0;
var AppEnvKeys;
(function (AppEnvKeys) {
    AppEnvKeys["Development"] = "development";
    AppEnvKeys["Production"] = "production";
    AppEnvKeys["Staging"] = "staging";
    AppEnvKeys["Test"] = "test";
})(AppEnvKeys = exports.AppEnvKeys || (exports.AppEnvKeys = {}));
var ApiProtocol;
(function (ApiProtocol) {
    ApiProtocol["Http"] = "http";
    ApiProtocol["Https"] = "https";
})(ApiProtocol = exports.ApiProtocol || (exports.ApiProtocol = {}));
var BreakpointTypes;
(function (BreakpointTypes) {
    BreakpointTypes["Lg"] = "lg";
    BreakpointTypes["Md"] = "md";
    BreakpointTypes["Sm"] = "sm";
    BreakpointTypes["Xl"] = "xl";
    BreakpointTypes["Xs"] = "xs";
    BreakpointTypes["Xxs"] = "xxs";
})(BreakpointTypes = exports.BreakpointTypes || (exports.BreakpointTypes = {}));
